import type { SVGProps } from 'react';

const SvgEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="email">
      <path d="M16 18.88h.14A2.65 2.65 0 0 0 18 18l9.27-8.68-1-1.1-9.33 8.74a1.22 1.22 0 0 1-.87.45 1.2 1.2 0 0 1-.89-.33L5.76 8.36l-1 1.1 9.39 8.69a2.7 2.7 0 0 0 1.85.73" />
      <path d="M.69 25.18a2.75 2.75 0 0 0 2.75 2.75h25.12a2.75 2.75 0 0 0 2.75-2.75v-18a2.75 2.75 0 0 0-2.75-2.75H3.44A2.75 2.75 0 0 0 .69 7.14Zm1.5-18a1.25 1.25 0 0 1 1.25-1.29h25.12a1.25 1.25 0 0 1 1.25 1.25v18a1.25 1.25 0 0 1-1.25 1.25H3.44a1.25 1.25 0 0 1-1.25-1.25Z" />
    </g>
  </svg>
);

export default SvgEmail;
